/* -------------- Queries ---------- */

export const queryUsers = `
query queryUsers  {
  users {
    id
    full_name
    first_name
    email
    last_name
    preferred_email
    meta
  }
}
`;

export const queryWorkspaceProps = `
query queryWorkspaceProps  {
  billing_plans {
    id
    appid
    billing_amount
    billing_schedule
  }
  installations {
    appid
    status
    release_channel
    id
  }
  feature_access {
    feature_flag
  }
  workspaces {
    accountid
    id
    userid
    sourceid
    user {
      email
      full_name
    }
    source {
      source_meta(args:{hasura_session:{}})
      source_domain
      onboarding_progress
      offer_onboarding
      cornercart_onboarding
      default_language
      currency_format
      tracking_pixels
      source_details
      translated_languages
    }
  }
}
`;

/* --------------- Mutations ------------------- */
export const updateSourceDetails = `
  mutation updateSourceDetails ($sourceId:sources_pk_columns_input!, $sourceInput:sources_set_input){
    update_sources_by_pk(pk_columns: $sourceId, _set:$sourceInput) {
      id
    }
  }
`;
export const updateUserDetails = `
  mutation updateUserDetails ($userId:users_pk_columns_input!, $userInput:users_set_input,$installationId:installations_pk_columns_input!,$installationInput:installations_set_input){
    update_users_by_pk(pk_columns: $userId, _set:$userInput) {
      id
    }
    update_installations_by_pk(pk_columns: $installationId, _set:$installationInput) {
      id
    }
  }
`;

export const updateOnboardingDetails = `
  mutation updateOnboardingDetails ($widgetSettingsId:widgets_cornerwidget_pk_columns_input!, $widgetSettingsInput:widgets_cornerwidget_set_input, $sourceId:sources_pk_columns_input!, $sourceInput:sources_set_input){
    update_sources_by_pk(pk_columns: $sourceId, _set:$sourceInput) {
      id
    }
    update_widgets_cornerwidget_by_pk(pk_columns: $widgetSettingsId, _set:$widgetSettingsInput) {
      id
    }
  }
`;
